// When Nuxt fails to load a lazy chunk or the builds manifest JSON after a
// redeployment, client-side navigation breaks silently. The user's browser
// holds a reference to an old deployment whose assets no longer exist on the
// CDN. Reloading the page forces a fresh fetch of the current deployment,
// restoring normal navigation without the user having to manually refresh.
export default defineNuxtPlugin((nuxtApp) => {
  // Chunk load failure: /_nuxt/chunks/… assets missing after redeployment
  nuxtApp.hook('app:chunkError', () => {
    reloadNuxtApp()
  })

  // Build manifest fetch failure: /_nuxt/builds/meta/…json missing after
  // redeployment. This surfaces as a Vue Router navigation error.
  const router = useRouter()
  router.onError((error) => {
    if (String(error?.message).includes('/_nuxt/builds/meta')) {
      reloadNuxtApp()
    }
  })
})
